module.exports = __webpack_public_path__ + "img/19.5d0739a5.png";